export default "__VITE_ASSET__f6ced70d__"